export default __webpack_public_path__ + "static/media/about.018680b7.jpg";